import React, { Component } from 'react'
import GreenButtonHeader from './misc/GreenButtonHeader'
import Card from './Results/Card'
import StartPlan from './Results/StartPlan'
import GreenButton from './misc/GreenButton'
import axios from 'axios'
import Chart2 from './Results/Chart2';

export class Results extends Component {
  state = {
    categories: [],
    categoryArr: [],
    colorArr: [],
    scoreArr: [],
  }

  componentWillMount() {
    const { resultId } = this.props.match.params
    axios.get(`http://web.wholechildapp.com/api/results/${resultId}`)
      .then(res => {
        const data = res.data.data;
        const startPlan = res.data.startPlan;
        this.setState({ categories: data });
        this.setState({ startPlan })
        let categoryArr = [], colorArr = [], scoreArr = [];
        this.state.categories.map(element => {
          categoryArr.push(element.name);
          colorArr.push(element.color);
          scoreArr.push(element.score);
        })
        this.setState({ categoryArr: categoryArr })
        this.setState({ scoreArr: scoreArr })
        this.setState({ colorArr: colorArr })
      });
  }

  goToHomepage() {
    window.location.href = "/quiz"
  }

  createCards = () => {
    const { categories } = this.state;
    if (categories) {
      return categories.map(bullet => {
        // if (bullet.score < 70) {
        return <Card key={bullet.id}
          name={bullet.name}
          howMuch={bullet.score}
          addColor={bullet.color}
          description={bullet.score < 70 ? bullet.message : bullet.text_above_average} />
        // }
      }
      )
    }
  }

  render() {
    return (
      <div>
        <div className="add-grey">
          <div className="bar">
            <img className="headerLogo" src={require("../assets/imgs/logo-blue.png")} alt="logo" />
            <p className="headerText">6 Areas of Development Test Results</p>
            <GreenButtonHeader nextStep={this.goToHomepage} name="RETAKE TEST" />
          </div>
          {/* <p className="chooseAgeText">Your Development Test Results</p> */}
          <div className="onlyResultMobile">
            <img className="headerLogo" src={require("../assets/imgs/logo-blue.png")} alt="logo" />
            <p className="resultsMean">6 Areas of Development Test Results</p>
          </div>
          <Chart2 colors={this.state.colorArr} categories={this.state.categoryArr} values={this.state.scoreArr} />
          <img alt="snake-small" className="white-snake-results" src={require("../assets/imgs/white-snake-small.png")} />
        </div>

        <div className="align-center">
          <img alt="idea" src={require("../assets/imgs/idea.png")} />
          <p className="resultsMean">What do your results really mean?</p>
        </div>
        <div className="card-wallet">
          {this.createCards()}
          <StartPlan link={this.state.startPlan} />
        </div>
        <form action="/" className="welcome-end-grey">
          <GreenButton name="RETAKE TEST" />
        </form>
      </div>
    )
  }
}

export default Results
